import { type ReactNode } from 'react';
import { createPortal } from 'react-dom';

// Popovers and sheets render here, not where they are declared. Every
// surface that hosts a picker turned out to be hostile to an in-tree
// overlay: the home hero clips it (`overflow-hidden`), the search summary
// bar captures `position: fixed` for its `backdrop-filter`, and the
// apartment sidebar sticks out of reach. `document.body` has none of those
// properties and never will. See the OH-130 spec §2 for the measurements.
//
// GuestNav.tsx already solves the same problem by declaring its mobile
// overlay as a SIBLING of the blurred wrapper — this is that idea made
// reusable, for the cases where a sibling is not reachable from where the
// component lives.
export function Portal({ children }: { children: ReactNode }): ReactNode {
  if (typeof document === 'undefined') return null;
  return createPortal(children, document.body);
}
